'use client';

import React from 'react';
import type { ChatMessageBubbleProps } from './types';

const VARIANT_CLASSES = {
  user: 'bg-blue-600 text-white rounded-2xl rounded-tr-sm px-4 py-3 text-sm leading-relaxed whitespace-pre-wrap',
  assistant:
    'bg-white border border-neutral-200 rounded-2xl rounded-tl-sm px-4 py-3 text-sm text-neutral-800 leading-relaxed shadow-sm min-w-0 max-w-full',
} as const;

const ChatMessageBubble: React.FC<ChatMessageBubbleProps> = ({
  variant,
  children,
  className = '',
  'data-testid': testId,
}) => (
  <div className={`${VARIANT_CLASSES[variant]} ${className}`} data-testid={testId}>
    {children}
  </div>
);

export default ChatMessageBubble;
